import script from "./AnnouncementsEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementsEdit.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementsEdit.vue?vue&type=style&index=0&id=4f111e01&lang=scss"

const __exports__ = script;

export default __exports__